import BackgroundCheck from '../util/background-check.min.js';
import balanceText from '../util/balancetext.min.js';

export default {
  init() {
		// JavaScript to be fired on all pages

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired

		/**
		 * Mobile Menu Toggler
		 */
		$('button.hamburger').on('click', function(){
			if( !$(this).hasClass('is-active') ){ $('nav.nav-primary').scrollTop(0); }
			$(this).toggleClass('is-active');
			$('body').toggleClass('nav-open');
		});

		$(document).on('click', function (e) {
			if (!$(e.target).closest('nav.nav-primary').length && !$(e.target).closest('button.hamburger').length) {
				$('button.hamburger').removeClass('is-active');
				$('body').removeClass('nav-open');
			}
		});


		/**
		 * Define SEO friendly method for multiple links to same dest.
		 * Example : <div class="link-master"><a href="#" class="link">MAIN LINK</a><img class="link-slave" /></div>
		 */
		$('body').on('click', '.link-slave', function(){
			var $master 	= $(this).parents('.link-master');
			var $reallink = $($master).find('a.link');
      $reallink[0].click();
		});


		/**
		 * Init balanceText
		 */
		balanceText($('.balance-text, h2'), {watch: true});


    /**
		 * Define Click event for Video-youtube-widget :
		 */
		$('.video-youtube-widget').on('click', 'a.cta_video', function(){

      // Display overflow
      $('body').addClass('has-lightbox');
      // Build lightbox
      var video_id = $(this).attr('data-videoid');
      var video_iframe = '<iframe width="100%" height="100%" src="https://www.youtube.com/embed/'+video_id+'?rel=0&amp;showinfo=0&amp;autoplay=1" frameborder="0" allowfullscreen></iframe>';
      $('body').prepend('<div class="lightbox"><a class="closer"></a>'+video_iframe+'</div>');
      $('.lightbox').fadeIn();

    });
    $('body').on('click', '.lightbox a.closer, .overlay', function(){
      $('.lightbox').fadeOut('300', function(){ $(this).remove(); $('body').removeClass('has-lightbox'); });

    });


		/**
		 *  Init FullPage.js
		 */
		var scroll_overflow = $(window).width() < 992 ? false : true;
		initFullPage();

		function responsiveFullPage(){

			var verif = $(window).width() < 992 ? false : true;
			if(scroll_overflow !== verif ){
				$.fn.fullpage.destroy('all');
				scroll_overflow = verif;
				initFullPage();
			}

		}

		function initFullPage( ){

			$('.container .row').fullpage({

			//Navigation
			menu: '#menu',
			lockAnchors: true,
			navigation: false,
			navigationPosition: 'right',
			navigationTooltips: ['firstSlide', 'secondSlide'],
			showActiveTooltip: false,
			slidesNavigation: false,
			slidesNavPosition: 'bottom',

			//Scrolling
			css3: true,
			scrollingSpeed: 700,
			autoScrolling: true,
			fitToSection: true,
			fitToSectionDelay: 1000,
			scrollBar: true,
			easing: 'easeInOutCubic',
			easingcss3: 'ease',
			loopBottom: false,
			loopTop: false,
			loopHorizontal: true,
			continuousVertical: false,
			continuousHorizontal: false,
			scrollHorizontally: false,
			interlockedSlides: false,
			dragAndMove: false,
			offsetSections: false,
			resetSliders: false,
			fadingEffect: false,
			normalScrollElements: '#element1, .element2',
			scrollOverflow: scroll_overflow,
			scrollOverflowReset: false,
			scrollOverflowOptions: null,
			touchSensitivity: 15,
			normalScrollElementTouchThreshold: 5,
			bigSectionsDestination: null,

			//Accessibility
			keyboardScrolling: true,
			animateAnchor: true,
			recordHistory: true,

			//Design
			controlArrows: true,
			verticalCentered: true,
			sectionsColor : ['#ccc', '#fff'],
			paddingTop: '',
			paddingBottom: '',
			fixedElements: '#site-header',
			responsiveWidth: 992,
			responsiveHeight: 0,
			responsiveSlides: false,
			parallax: false,
			parallaxOptions: {type: 'reveal', percentage: 62, property: 'translate'},

			//Custom selectors
			sectionSelector: 'div.section',
			slideSelector: '.slide',

			lazyLoading: true,

			//events
			onLeave: function(){},
			afterLoad: function(){
				BackgroundCheck.init({
					targets: 'body, nav.nav-secondary, .checkcolor',
					images: '.section.active',
				});
			},
			afterRender: function(){ },
			afterResize: function(){ },
			afterResponsive: function(){
				responsiveFullPage();
			},
			afterSlideLoad: function(anchorLink, index, slideAnchor, slideIndex){ console.log('afterSlideLoad' + anchorLink + ' / ' + index + ' / ' + slideAnchor + ' / ' + slideIndex ); },
			onSlideLeave: function(anchorLink, index, slideIndex, direction, nextSlideIndex){ console.log('onSlideLeave' + index + ' / ' + slideIndex + ' / ' + direction+ ' / ' + nextSlideIndex ); },

		});

		}

    /**
		 *  Blog : Load More
		 */
    $('body').on('click', 'a.load-more-posts', function(){
      var nonce = $('a.load-more-posts').attr('data-check');
			$.ajax({
					url		: starter.ajaxurl,
					async	: true,
					method: 'POST',
					data: {
            action					: 'load_more_posts',
						load_more_posts	: nonce,
						offset					: $('article.type-post').length,
					},
					success: function (response) {
						var respData = jQuery.parseJSON(response);
						if(respData.status === 'success' ){
							if( !respData.has_other_posts ){
								$('a.load-more-posts').fadeOut();
							}
							var $items = $(''+respData.posts+'');
              $($items).insertBefore('a.load-more-posts');

						}
					},
				});

    });

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js